import { Component, OnInit ,Inject} from '@angular/core';
import {NgForm} from '@angular/forms';
import { CustomersService }   from 'src/app/Api_Module';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'crg-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  protected basePath = 'https://localhost';
  constructor(private customerService: CustomersService, private toast : ToastrService) { 

  }

  ngOnInit() {
  }
  onSubmit(form: NgForm) {
    this.customerService.feedback(form.value).subscribe(res => {
      this.toast.info('Your query was submitted');
      form.resetForm();
    });

}

}
